var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',[_c('vs-autocomplete',{attrs:{"data-test":"group-selector-field","items":_vm.items,"label":_vm.title,"hint":_vm.description,"value":_vm.formData,"error-messages":_vm.errorMessages,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }